import { Circle } from '@mui/icons-material'
import { Icon, Stack, Tooltip } from '@mui/material'
import type { GridRenderCellParams } from '@mui/x-data-grid-pro'
import dayjs from 'dayjs'
import { useUser } from '@/features/auth/hooks/useUser'

export const BulkEditIndicatorCell = (params: GridRenderCellParams) => {
  const {
    selectors: { selectUserData, selectUserRights },
  } = useUser()
  const data = selectUserData()
  const rights = selectUserRights()

  const userCws = data?.catloginid ?? ''

  let isRecent = false

  const sixHoursInMs = 6 * 60 * 60 * 1000
  const date = dayjs(params.row.lastBulkEditDate)
  const lastBulkEditedBy = params.row.lastBulkEditModifiedBy

  const isEditedByUser = lastBulkEditedBy === userCws

  if (date.isValid() && dayjs().diff(date) < sixHoursInMs) {
    isRecent = true
  }

  const shouldShowIndicator = isEditedByUser && isRecent

  if (!rights.canBulkEdit) return params.formattedValue ?? params.value ?? ''

  return (
    <Stack
      direction="row"
      height="100%"
      alignItems={'center'}
      justifyContent={'start'}
      gap={1}
    >
      {shouldShowIndicator ? (
        <Tooltip title="Bulk Edited Recently" arrow>
          <Circle fontSize="small" color="success" />
        </Tooltip>
      ) : (
        <Icon fontSize="small" />
      )}
      {params.value}
    </Stack>
  )
}
